import React from "react";
import Seo from "../components/Seo";

const Download = () => {
  return (
    <main className="page page-download">
      <Seo
        title="Download Android App"
        description="Download the OctoGames Android app and install it in minutes. Follow the quick APK setup steps."
        path="/download"
        keywords="octogames android app, download apk, install game app"
      />
      <div className="container">
        <header className="download-header">
          <h1 className="download-title">Download Android App</h1>
          <p className="download-subtitle">
            Install the OctoGames web-view app on your Android phone or tablet.
          </p>
        </header>

        <section className="download-card">
          <h2 className="download-card-title">Step 1 — Download APK</h2>
          <p className="download-text">
            Tap the button below to download the latest APK file.
          </p>
          <a
            href="/download/OctoGames.apk"
            className="btn btn-primary download-apk-btn"
            download="OctoGames.apk"
          >
            <span className="download-btn-desktop">Download APK</span>
            <span className="download-btn-mobile">⬇ APK</span>
          </a>
        </section>

        <section className="download-card download-steps">
          <h2 className="download-card-title">Step 2 — Allow Installation</h2>
          <ol className="download-list">
            <li>Open the downloaded APK from your browser downloads.</li>
            <li>
              If Android asks for permission, enable{" "}
              <strong>&quot;Allow from this source&quot;</strong>.
            </li>
            <li>Confirm installation and wait until it finishes.</li>
          </ol>
        </section>

        <section className="download-card download-steps">
          <h2 className="download-card-title">Step 3 — Open the app</h2>
          <ol className="download-list">
            <li>Find the OctoGames icon on your home screen or in the app list.</li>
            <li>Open the app — it will load this website inside a web view.</li>
            <li>Sign in with your account to sync stats and recent games.</li>
          </ol>
        </section>
      </div>
    </main>
  );
};

export default Download;

